import React, { useState } from 'react';
import './Stakeholder.css';
import stakeholderImg from '../assets/images/website-stakeholder.jpg';
import { FaFilePdf } from 'react-icons/fa';
import Footer from './Footer';

const stakeholderData = [
  {
    title: 'Annual Return',
    documents: [
      { name: 'Annual Return_2024-25', link: '/pdfs/Annual Return_2024-25.pdf' },
      { name: 'Annual Return_2023-24', link: '/pdfs/Annual Return_2023-24.pdf' },
      { name: 'Annual Return_2022-23', link: '/pdfs/Annual Return_ 2022-23.pdf' },
      { name: 'Annual Return_2021-22', link: '/pdfs/Annual Return_2021-22.pdf' },
      { name: 'Annual Return_2020-21', link: '/pdfs/Annual Return_2020-21.pdf' },
      { name: 'Annual Return_2019-20', link: '/pdfs/Annual Return_2019-20.pdf' },
    ],
  },
  {
    title: 'Notice of GM',
    subSections: [
      {
        title: 'AGM',
        documents: [
          { name: 'AGM Notice_2024-25', link: '/pdfs/AGM-Notice_2024-25.pdf' },
          { name: 'AGM Notice_2023-24', link: '/pdfs/AGM-Notice_2023-24.pdf' },
        ],
      },
    ],
  },
  {
    title: 'Resignation of Director',
    documents: [
      { name: 'Resignation letter - Saumya Sarda', link: '/pdfs/1.-Resignation-letter_Saumya-Sarda.pdf' },
    ],
  },
];

function DocCards({ documents }) {
  return (
    <div className="stakeholder-documents">
      {documents.map((doc, docIndex) => (
        <a
          key={docIndex}
          href={doc.link}
          className="stakeholder-doc-card"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="stakeholder-doc-icon">
            <FaFilePdf size={40} />
          </div>
          <p className="stakeholder-doc-name">{doc.name}</p>
        </a>
      ))}
    </div>
  );
}

function SubSection({ sub }) {
  const [open, setOpen] = useState(true);

  return (
    <div className="stakeholder-subsection">
      <div className="stakeholder-subsection-header">
        <h4 className="stakeholder-subsection-title">{sub.title}</h4>
        <button
          className="stakeholder-toggle-btn"
          onClick={() => setOpen(!open)}
        >
          {open ? 'View Less −' : 'View More +'}
        </button>
      </div>
      {open && <DocCards documents={sub.documents} />}
    </div>
  );
}

function Stakeholder() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="stakeholder-page">
      <div className="stakeholder-hero">
        <div className="container">
          <img
            src={stakeholderImg}
            alt="Stakeholder"
            className="stakeholder-hero-img"
          />
        </div>
      </div>

      <div className="stakeholder-content container">
        {stakeholderData.map((section, index) => (
          <div key={index} className="stakeholder-section">
            <div className="stakeholder-section-header">
              <h3 className="stakeholder-section-title">{section.title}</h3>
              <button
                className="stakeholder-toggle-btn"
                onClick={() => toggleSection(index)}
              >
                {openIndex === index ? 'View Less −' : 'View More +'}
              </button>
            </div>
            {openIndex === index && (
              <div className="stakeholder-section-body">
                {section.documents && <DocCards documents={section.documents} />}
                {section.subSections &&
                  section.subSections.map((sub, subIndex) => (
                    <SubSection key={subIndex} sub={sub} />
                  ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default Stakeholder;
